class DeleteMessageWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.translate = this.injector.get('$translate');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.stateParams = this.injector.get('$stateParams');

        this.back = this.stateParams.back;
        this.params = this.stateParams.backParams || {
            id: this.stateParams.id
        };

        this.key = 'delete-message';
        this.title = this.translate.instant('general.verbs.delete');
        this.level = 'archived-highlight';
        this.icon = 'fal fa-trash-alt';
        this.order = 15;

    }

    action(message, vm) {

        const translatedValue = (path, params) => {
            return this.translate.instant(`messages.workflows.ask-to-delete-message.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', { message_subject: message.subject || 'message' }),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            return this.api.delete(`messages/${message.id}`, {data: {force: true}})
                .then(() => {
                    return this.state.go(this.back, this.params);
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.modules.messages')
    .factory('deleteMessage', [
        '$injector',
        ($injector) => new DeleteMessageWorkflow($injector)
    ]);




// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/details/delete.js